import React, { useState } from 'react';
import { validateStep3 } from '../lib/onboardingSchema';
import { prepareClimboSetup } from '../lib/climboApi';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function IntegrationStep({ data, onChange, onNext, onBack }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isValid = validateStep3(data);

  const handleSetup = async () => {
    setIsSubmitting(true);
    try {
      // Mock API call to setup Climbo / NinjaPipe
      const result = await prepareClimboSetup(data);
      if (result.success) {
        onNext();
      }
    } catch (error) {
      console.error('Setup failed', error);
      alert('There was an issue preparing your setup. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h3 className="text-xl text-brand-deep mb-2">Connect Your Data</h3>
        <p className="text-gray-600">Let's prepare your RepUpgrade environment.</p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="label-text mb-3">Do you have an existing customer list?</label>
          <div className="flex space-x-4">
            {['Yes', 'No'].map(option => (
              <label key={option} className={`flex-1 flex items-center justify-center p-3 border rounded-lg cursor-pointer transition-all ${data.hasExistingList === option ? 'border-brand-accent bg-brand-accent/5 text-brand-deep font-medium' : 'border-gray-200 text-gray-600 hover:border-brand-signal'}`}>
                <input 
                  type="radio" 
                  name="existingList"
                  className="hidden"
                  value={option}
                  checked={data.hasExistingList === option}
                  onChange={(e) => onChange('hasExistingList', e.target.value)}
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        {data.hasExistingList === 'Yes' && (
          <div className="animate-fadeIn">
            <label className="label-text">What CRM or tool stores your contacts?</label>
            <input 
              type="text" 
              className="input-field" 
              placeholder="e.g. HubSpot, QuickBooks, Excel Spreadsheet"
              value={data.crmSource}
              onChange={(e) => onChange('crmSource', e.target.value)}
              style={{ color: '#101F1F', backgroundColor: '#FFFFFF', WebkitTextFillColor: '#101F1F' }}
            />
          </div>
        )}

        <div className="bg-gray-50 p-5 rounded-lg border border-gray-100 mt-8">
          <label className="flex items-start cursor-pointer">
            <div className="mt-1">
              <input 
                type="checkbox" 
                className="w-5 h-5 text-brand-accent rounded border-gray-300 focus:ring-brand-accent"
                checked={data.dataConsent}
                onChange={(e) => onChange('dataConsent', e.target.checked)}
              />
            </div>
            <div className="ml-3">
              <span className="block text-brand-deep font-medium mb-1">Data Processing Consent *</span>
              <span className="text-sm text-gray-500">
                I authorize Digital Cowboy to prepare my RepUpgrade environment and process my business details for the purpose of setting up review channels and automated campaigns.
              </span>
            </div>
          </label>
        </div>
      </div>

      <div className="pt-6 mt-6 border-t border-gray-100 flex justify-between">
        <button onClick={onBack} disabled={isSubmitting} className="btn-secondary">
          Back
        </button>
        <button 
          onClick={handleSetup} 
          disabled={!isValid || isSubmitting}
          className="btn-primary"
        >
          {isSubmitting ? (
            <>Processing Setup...</>
          ) : (
            <>Prepare RepUpgrade Setup <SafeIcon icon={FiIcons.FiSettings} /></>
          )}
        </button>
      </div>
    </div>
  );
}